import { Theme } from './theme.interface';
import { Contrast } from './contrast.theme';

export const ContrastPink: Theme = {
	...Contrast, // Inherit parent contrast theme colours, spinner, blacks and whites etc.
    name: 'ContrastPink',
	properties: (() => { 
		const primary = '#F9ADDE';
		const secondary = '#D5A5C4';
		const tertiary = '#d8ccd0'

		return {
			...Contrast.properties,

			// Primary colours
			...Object.fromEntries(
				['--background-secondary', '--background-tertiary', '--background-quaternary', '--or-background', '--preview-one']
					.map(key => [key, primary])
			),

			// Secondary colours
			...Object.fromEntries(
				[
					'--background-default',
					'--button-primary-background',
					'--button-secondary-background',
					'--button-accent-background',
					'--loading-background',
					'--dialog-background',
					'--mca-background',
				].map(key => [key, secondary])
			),

			// Tertiary Colours
			...Object.fromEntries(
				[
					'--button-primary-background-disabled',
					'--button-secondary-background-disabled',
				].map(key => [key, tertiary])
			),
		};
		})(),
    canSelect: true
};
